
/**
 * (customers + depot) x (customers + depot) distance matrix
 * so last row and colum nare the distances to the depot
 */
export const distance = [
  [0, 6415, 2565, 2775, 3910, 1891, 4185, 5848, 3715, 5245, 2704, 5118, 2823],
  [6841, 0, 6233, 4694, 5532, 8018, 4955, 1737, 3595, 4725, 6372, 3902, 4856],
  [2306, 8430, 0, 4755, 3104, 3872, 5232, 6899, 5696, 7225, 985, 6374, 4837],
  [2526, 4833, 3488, 0, 4833, 3703, 4884, 4287, 3015, 4545, 3627, 3557, 2711],
  [4061, 5639, 2651, 4838, 0, 5627, 2128, 3795, 6259, 7578, 2822, 3270, 3240],
  [1743, 8055, 3617, 3708, 5653, 0, 5928, 7608, 4649, 6178, 4447, 6879, 4566],
  [4365, 5055, 4038, 4817, 2130, 5931, 0, 3210, 5674, 6993, 4177, 2685, 3544],
  [6063, 1845, 5753, 4296, 3795, 7622, 3218, 0, 4029, 5159, 5892, 2165, 3119],
  [3246, 3850, 5818, 2719, 6582, 4423, 6005, 4235, 0, 1974, 5957, 4679, 4157],
  [5019, 4703, 6901, 4491, 7549, 6196, 6972, 5087, 1773, 0, 7040, 5646, 5240],
  [2145, 8268, 903, 4594, 3624, 3710, 6038, 7701, 5534, 7064, 0, 6971, 4676],
  [4357, 4302, 4048, 2590, 3632, 5917, 3055, 2458, 3874, 5192, 4187, 0, 1413],
  [3033, 4652, 2706, 2641, 3272, 4599, 3548, 3103, 3944, 5262, 2845, 1591, 0]
];

export const travelTime = [
  [0, 7, 3, 3, 4, 2, 4, 6, 3, 5, 3, 5, 3],
  [7, 0, 7, 6, 6, 8, 6, 2, 4, 6, 7, 5, 6],
  [3, 9, 0, 6, 4, 5, 6, 8, 6, 8, 2, 7, 6],
  [3, 6, 4, 0, 5, 5, 5, 5, 3, 5, 5, 4, 4],
  [4, 6, 3, 5, 0, 6, 2, 4, 6, 8, 3, 3, 4],
  [2, 8, 5, 5, 6, 0, 6, 7, 4, 6, 5, 7, 5],
  [4, 6, 4, 5, 2, 6, 0, 4, 5, 7, 5, 3, 4],
  [6, 2, 6, 5, 4, 7, 4, 0, 4, 6, 6, 3, 4],
  [3, 4, 6, 3, 6, 4, 6, 5, 0, 2, 6, 5, 5],
  [5, 6, 7, 5, 7, 6, 7, 6, 2, 0, 7, 6, 6],
  [3, 9, 2, 6, 4, 4, 7, 8, 6, 7, 0, 7, 6],
  [4, 5, 4, 3, 4, 6, 4, 3, 4, 6, 5, 0, 3],
  [4, 6, 4, 4, 4, 5, 4, 4, 4, 6, 4, 3, 0]
];
